module.exports = __webpack_public_path__ + "static/building_red-a6a3c0be56a03ff07279486c1878a544.gif";